import * as locales from '../../Locales';

export const locale = (lang, path) => {
  const loc = locales[lang][path];
  return loc;
};
